angular.module("app").constant("uploadImageParams", {
    imageSiza: 4194304,
    imageWarningSize:409600,
    gifWarningSize:1048576
});